import EdgeworthIcon from '@office-start/edgeworth-icon';
import React from 'react';
export function getFiltersFromConfig(filtersConfig, locResources, onPivotRefChange) {
    var customFiltersFromConfig = filtersConfig.map(function (filter) {
        var customFilter = {
            id: filter.id ? filter.id : '',
            title: filter.title ? locResources[filter.title] : '',
            iconElement: filter.icon ? (React.createElement(EdgeworthIcon, { iconName: filter.icon })) : undefined,
            ariaLabel: filter.ariaLabel
                ? locResources[filter.ariaLabel]
                : undefined,
        };
        if (filter.id === 'favorites' && onPivotRefChange) {
            // Keeping it consistent with fixed 'Favorite' tab from useTabFilters
            customFilter.onPivotRefChange = function (element) {
                return onPivotRefChange('favorites', element);
            };
        }
        return customFilter;
    });
    return customFiltersFromConfig;
}
//# sourceMappingURL=getFiltersFromConfig.js.map